<div>
  <div class="report-container">
    <div class="report-header">
      <h2 class="pagetitle">Submission Summary Report : {{ currentYear }}</h2>
      <div class ="header-button-group">
        <button class="download-btn" (click)="downloadFullReport()" [disabled]="downloadingReport">
          <svg width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
            <path d="M.5 9.9v3.6a1 1 0 0 0 1 1h13a1 1 0 0 0 1-1V9.9h-2v3H2.5v-3h-2z" />
            <path
              d="M7.646 10.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 1 0-.708-.708L8.5 9.293V1.5a.5.5 0 0 0-1 0v7.793L5.354 7.146a.5.5 0 1 0-.708.708l3 3z" />
          </svg>
          Download Full Report
          <span *ngIf="downloadingReport" class="spinner">
            <svg width="18" height="18" viewBox="0 0 50 50">
              <circle cx="25" cy="25" r="20" fill="none" stroke="#0078d4" stroke-width="5" stroke-linecap="round"
                stroke-dasharray="31.4 31.4" transform="rotate(-90 25 25)">
                <animateTransform attributeName="transform" type="rotate" from="0 25 25" to="360 25 25" dur="0.8s"
                  repeatCount="indefinite" />
              </circle>
            </svg>
          </span>
        </button>
        <!-- Expand/Collapse All as links -->
        <a (click)="expandAll()" class="view-more-link">Expand All</a>
        <a (click)="collapseAll()" class="view-more-link">Collapse All</a>
      </div>
    </div>
    <div class="sub-heading">
      <span class="pagetitleSecondLayerBold"> {{ prfNumber.toUpperCase() }} </span>:<span class="pagetitleSecondLayer">
        {{ prfName }}</span>
    </div>
    <div class="card" *ngFor="let r of rows">

      <!-- ROW (collapsed view) -->
      <div class="row-content" (click)="toggle(r)"  (keydown.enter)="toggle(r)">
        <div class="left">
          <div class="step-circle">{{ r.number }}</div>
          <div class="icon-container">
            <ng-container [ngSwitch]="r.icon">
              <!-- Company icon -->
              <svg *ngSwitchCase="'company'" xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                stroke-linejoin="round" class="lucide lucide-users h-5 w-5 text-chart-3" aria-hidden="true">
                <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"></path>
                <path d="M16 3.128a4 4 0 0 1 0 7.744"></path>
                <path d="M22 21v-2a4 4 0 0 0-3-3.87"></path>
                <circle cx="9" cy="7" r="4"></circle>
              </svg>
              <!-- Group icon -->
              <svg *ngSwitchCase="'group'" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                class="lucide lucide-users h-5 w-5 text-chart-3" aria-hidden="true">
                <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"></path>
                <path d="M16 3.128a4 4 0 0 1 0 7.744"></path>
                <path d="M22 21v-2a4 4 0 0 0-3-3.87"></path>
                <circle cx="9" cy="7" r="4"></circle>

              </svg>
              <!-- Statement icon -->
              <svg *ngSwitchCase="'statement'" xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                stroke-linejoin="round" class="lucide lucide-file-text h-5 w-5 text-chart-3" aria-hidden="true">
                <path
                  d="M6 22a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8a2.4 2.4 0 0 1 1.704.706l3.588 3.588A2.4 2.4 0 0 1 20 8v12a2 2 0 0 1-2 2z">
                </path>
                <path d="M14 2v5a1 1 0 0 0 1 1h5"></path>
                <path d="M10 9H8"></path>
                <path d="M16 13H8"></path>
                <path d="M16 17H8"></path>

              </svg>
              <!-- Premium icon -->
              <svg *ngSwitchCase="'premium'" xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                stroke-linejoin="round" class="lucide lucide-file-text h-5 w-5 text-chart-3" aria-hidden="true">
                <path
                  d="M6 22a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8a2.4 2.4 0 0 1 1.704.706l3.588 3.588A2.4 2.4 0 0 1 20 8v12a2 2 0 0 1-2 2z">
                </path>
                <path d="M14 2v5a1 1 0 0 0 1 1h5"></path>
                <path d="M10 9H8"></path>
                <path d="M16 13H8"></path>
                <path d="M16 17H8"></path>

              </svg>
              <!-- Userdefined icon -->
              <svg *ngSwitchCase="'userdefined'" xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                stroke-linejoin="round" class="lucide lucide-file-text h-5 w-5 text-chart-3" aria-hidden="true">
                <path
                  d="M6 22a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8a2.4 2.4 0 0 1 1.704.706l3.588 3.588A2.4 2.4 0 0 1 20 8v12a2 2 0 0 1-2 2z">
                </path>
                <path d="M14 2v5a1 1 0 0 0 1 1h5"></path>
                <path d="M10 9H8"></path>
                <path d="M16 13H8"></path>
                <path d="M16 17H8"></path>

              </svg>
              <!-- Comments icon -->
              <svg *ngSwitchCase="'comments'" xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                stroke-linejoin="round" class="lucide lucide-message-square h-5 w-5 text-chart-3" aria-hidden="true">
                <path
                  d="M22 17a2 2 0 0 1-2 2H6.828a2 2 0 0 0-1.414.586l-2.202 2.202A.71.71 0 0 1 2 21.286V5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2z">
                </path>

              </svg>
              <!-- Validation icon -->
              <svg *ngSwitchCase="'validation'" xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                stroke-linejoin="round" class="lucide lucide-shield h-5 w-5 text-chart-3" aria-hidden="true">
                <path
                  d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z">
                </path>

              </svg>
            </ng-container>
          </div>
        </div>

        <div class="middle">
          <div class="title">{{ r.title }}</div>
        </div>

        <div class="right">
          <div class="status-actions">
            <div class="status-badge"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                class="lucide lucide-circle-check h-3 w-3 mr-1" aria-hidden="true">
                <circle cx="12" cy="12" r="10"></circle>
                <path d="m9 12 2 2 4-4"></path>
              </svg> Completed</div>
            <button class="view-btn" (click)="$event.stopPropagation(); toggle(r)">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                class="lucide lucide-eye h-4 w-4 mr-1" aria-hidden="true">
                <path
                  d="M2.062 12.348a1 1 0 0 1 0-.696 10.75 10.75 0 0 1 19.876 0 1 1 0 0 1 0 .696 10.75 10.75 0 0 1-19.876 0">
                </path>
                <circle cx="12" cy="12" r="3"></circle>
              </svg> {{ r.expanded ? 'Close' : 'View' }}
            </button>
          </div>
        </div>
      </div>

      <!-- EXPANSION PANEL -->
      <div class="expand-panel" *ngIf="r.expanded">
        <div class="panel-card table-responsive">
          <ng-container [ngSwitch]="r.number">
            <app-companyinfo-summary *ngSwitchCase="1" [currentYear]="currentYear" [prfNumber]="prfNumber"
              [groupCode]="groupCode">
            </app-companyinfo-summary>
            <app-groupreporting-summary *ngSwitchCase="2" [currentYear]="currentYear" [prfNumber]="prfNumber"
              [groupCode]="groupCode">
            </app-groupreporting-summary>
            <app-annualstatement-summary *ngSwitchCase="3" [currentYear]="currentYear" [prfNumber]="prfNumber"
              [groupCode]="groupCode">
            </app-annualstatement-summary>
            <app-premiumreport-summary *ngSwitchCase="4" [currentYear]="currentYear" [prfNumber]="prfNumber"
              [groupCode]="groupCode">
            </app-premiumreport-summary>
            <app-userdefined-summary *ngSwitchCase="5" [currentYear]="currentYear" [prfNumber]="prfNumber"
              [groupCode]="groupCode">
            </app-userdefined-summary>
            <app-comments-summary *ngSwitchCase="6" [currentYear]="currentYear" [prfNumber]="prfNumber"
              [groupCode]="groupCode">
            </app-comments-summary>
            <app-validationsummary-summary *ngSwitchCase="7" [currentYear]="currentYear" [prfNumber]="prfNumber"
              [groupCode]="groupCode">
            </app-validationsummary-summary>
          </ng-container>
        </div>
      </div>

    </div>
  </div>
</div>